module.exports = __webpack_public_path__ + "img/47.17764691.png";